// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V22H2V2ZM12 18.25L16 12H13V6H11V12L8 12L12 18.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-arrow-down-rectangle-filled')
export default class ArrowDownRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-down-rectangle-filled',
    }
  }
}
